import { Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { INDRADatepickerModalComponent } from '@ibe.components/shared/datepicker-modal/datepicker-modal.indra.component';
import * as moment from 'moment';
import { MultipleModalService } from '@ibe.components/common/modal/multiple-modal/multiple-modal.indra.service';


@Component({
	selector: 'app-large-input-datepicker',
	templateUrl: './large-input-datepicker.indra.component.html',
	styleUrls: ['./large-input-datepicker.component.scss'],
	host: { class: 'app-large-input-datepicker' },
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => LargeInputDatepickerComponent)
		}
	]
})
export class LargeInputDatepickerComponent implements OnInit, OnDestroy {
	@Input() id;
	@Input() label;
	@Input() placeholderLabel;
	@Input() icon;
	@Input() required = false;
	@Input() minlength;
	@Input() maxlength;
	@Input() inputValue = '';
	@Input() disabledForm = false;
	@Input() parentForm: FormGroup = null;
	@Input() formControlName = null;
	@Input() errorMessage;
	@Input() hasError;
	@Input() datepickerOptions = {};
	@Input() isLoading = false;
	@Output() dateSelected = new EventEmitter();



	htmlElement = document.getElementsByTagName('html');

	isFilled = false;
	isFocused = false;
	isAlive = true;
	hasLabelVisible = false;
	isDate: boolean;

	constructor(
		private multiModalService: MultipleModalService,
	) {
	}

	ngOnInit() {
		this.isAlive = true;

		if (this.parentForm && this.formControlName) {
			const inputValue = this.parentForm.get(this.formControlName).value;
			if (inputValue) setTimeout(() => this.INDRA_handleBlur(inputValue), 1);
		}

	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	change($event) {
		this.inputValue = $event.target.value;
	}

	INDRA_printID() {
		return this.id;
	}

	INDRA_printIcon() {
		return this.icon;
	}

	INDRA_printLabel() {
		return this.placeholderLabel && !this.isFilled ? this.placeholderLabel : this.label;
	}

	INDRA_printStyle() {
		let style = '';
		if (this.isFilled && !this.isLoading)
			style += ' is-filled';
		if (this.isFocused)
			style += ' is-focused';
		if (this.isLoading)
			style += ' is-loading';
		if (this.disabledForm && !this.isLoading)
			style += ' is-disabled';
		if (this.hasError)
			style += ' has-error';
		if (this.icon)
			style += ' has-icon';
		if (this.hasLabelVisible)
			style += ' has-label-visible';

		return style;
	}

	INDRA_handleFocus($event) {
		this.isFocused = true;
	}

	INDRA_handleBlur(value) {
		const dateOnFocus = moment((value), 'YYYY-M-D').format('DD/MM/YYYY');

		if (dateOnFocus === 'Invalid date') {
			this.isDate = false;
		} else {
			this.isDate = true;
		}

		this.hasLabelVisible = true;
		this.isFocused = false;


		if (!this.hasLabelVisible) {
			this.label = '';
		}
		if (value === '') {
			this.isFilled = false;
		}

		if (this.parentForm && this.formControlName && value !== '' && this.isDate === true) {
			this.isFilled = true;
			this.inputValue = value;
			this.parentForm.get(this.formControlName).setValue(value);
			this.dateSelected.emit(this.inputValue);
		}
	}

	INDRA_showError() {
		return this.hasError;
	}

	// Function to call when the rating changes.
	onChange = (value) => { };

	// Function to call when the input is touched (when a star is clicked).
	onTouched = () => { };

	// Allows Angular to update the model (rating).
	// Update the model and changes needed for the view here.
	writeValue(value): void {
		this.onChange(value);
	}

	// Allows Angular to register a function to call when the model (rating) changes.
	// Save the function as a property to call later here.
	registerOnChange(fn: (rating: number) => void): void {
		this.onChange = fn;
	}

	// Allows Angular to register a function to call when the input has been touched.
	// Save the function as a property to call later here.
	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	// Allows Angular to disable the input.
	setDisabledState(isDisabled: boolean): void {
		this.disabledForm = isDisabled;
	}

	INDRA_printError() {
		return this.errorMessage;
	}

	INDRA_isRequired() {
		return this.required;
	}


	INDRA_openDatepickerModal() {
		const self = this;
		this.isAlive = true;

		const obj = {
			params: {
				datepickerOptions: this.datepickerOptions,
				value: this.parentForm.get(this.formControlName).value !== 'Invalid date' ? this.parentForm.get(this.formControlName).value : null
			},
			handleClose: (value) => {
				if (value && value.date) {
					const date = moment(`${value.date.year}-${value.date.month}-${value.date.day}`, 'YYYY-M-D').format('DD/MM/YYYY');
					self.INDRA_handleBlur(date);
				}
			}
		};

		this.multiModalService.create(INDRADatepickerModalComponent, obj);

	}
}
